import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAuth } from '../context/AuthContext';
import { useGymConfig } from '../context/GymConfigContext';
import { Input, Button, Card } from '../components';
import { loginSchema } from '../utils/validationSchemas';
import { toastMessages, handleApiError } from '../utils/toast';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

const Login = () => {
  const navigate = useNavigate();
  const { login } = useAuth();
  const { config } = useGymConfig();
  const logoSrc = config?.logo ? `${API_URL}${config.logo}` : null;
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginSchema),
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);
    
    try {
      const response = await login(data.email, data.password);
      
      toastMessages.loginExitoso();
      
      // Redirigir según el rol del usuario
      if (response.user.rol === 'admin') {
        navigate('/admin/dashboard');
      } else if (response.user.rol === 'entrenador') {
        navigate('/entrenador/dashboard');
      } else {
        navigate('/cliente/dashboard');
      }
    } catch (error) {
      if (error.response?.status === 401) {
        toastMessages.errorLogin();
      } else {
        handleApiError(error, 'Error al iniciar sesión');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login">
      <div className="login__container">
        <div className="login__header">
          {logoSrc
            ? <img src={logoSrc} alt={config.nombre} className="login__logo" />
            : <h1 className="login__title">{config?.nombre || 'PichTraining'}</h1>
          }
          {config?.slogan && (
            <p className="login__subtitle">{config.slogan}</p>
          )}
        </div>

        <Card className="login__card">
          <form onSubmit={handleSubmit(onSubmit)} className="login__form">
            <Input
              label="Email"
              type="email"
              {...register('email')}
              placeholder="tu@email.com"
              error={errors.email?.message}
              required
            />
            
            <Input
              label="Contraseña"
              type="password"
              {...register('password')}
              placeholder="••••••••"
              error={errors.password?.message}
              required
            />
            
            <Button
              type="submit"
              variant="primary"
              fullWidth
              loading={loading}
            >
              Iniciar Sesión
            </Button>
            
            <div className="login__footer">
              <Link to="/forgot-password" className="login__forgot-password-link">
                ¿Olvidaste tu contraseña?
              </Link>
            </div>
          </form>
        </Card>
      </div>
    </div>
  );
};

export default Login;
